module.exports = "../../../../platform/assets/pageMainIcon/yewuchulilei6.svg";